import {
  GET_CURRENT_CARD_DATA,
  JOIN_GROUP,
  LIST_ALL_USER_GAMES,
  LIST_PUBLIC_GROUPS,
  LIST_USER_DETAILS,
} from "../../graphql";
import { post, usergamePost, userpost } from "../../services";
import {
  RESET_PUBLIC_GROUPS,
  RESET_USER_CARDS,
  RESET_USER_DETAILS,
  RESET_USER_GAME,
  SAVE_PUBLIC_GROUPS,
  SAVE_USER_CARDS,
  SAVE_USER_DETAILS,
  SAVE_USER_GAME,
  TOGGLE_LOADING,
} from "../types";

const USERS_GRAPHQL_BASE_URL = "http://localhost:3092/graphql/users";

export const listUserDetails = () => {
  return async (dispatch, getState) => {
    dispatch({ type: TOGGLE_LOADING, payload: true });

    let apiResponse = await userpost("", {
      query: LIST_USER_DETAILS,
    });

    const userData = apiResponse?.data?.data?.list_user_details?.data;

    if (userData) {
      dispatch({
        type: SAVE_USER_DETAILS,
        payload: {
          username: userData.username,
          email: userData.email,
          id: userData._id,
        },
      });
    }
    dispatch({ type: TOGGLE_LOADING, payload: false });
  };
};

export const resetUserDetails = () => {
  return async (dispatch) => {
    dispatch({ type: RESET_USER_DETAILS });
  };
};

export const listUserGames = (userId, requestData = {}) => {
  return async (dispatch, getState) => {
    dispatch({ type: TOGGLE_LOADING, payload: true });

    try {
      const userState = getState().userProfile || {};
      const userGames = userState.games || {
        list: [],
        pageSize: 10,
        pageNumber: 1,
      };
      const { list, pageSize, pageNumber } = userGames;

      const apiResponse = await post("", {
        query: LIST_ALL_USER_GAMES,
        variables: {
          pageSize,
          pageNumber,
          userId,
          ...requestData,
        },
      });

      const gamesData = apiResponse?.data?.data?.list_all_user_games;

      if (apiResponse.data?.customStatus && gamesData) {
        const { data, hasMore } = gamesData;

        dispatch({
          type: SAVE_USER_GAME,
          payload: {
            list: [...list, ...data],
            showViewMore: hasMore,
            pageNumber: pageNumber + 1,
          },
        });
      }
    } catch (error) {
      console.error("Error fetching user games:", error);
    } finally {
      dispatch({ type: TOGGLE_LOADING, payload: false });
    }
  };
};

export const resetGames = () => ({
  type: RESET_USER_GAME,
});

export const listPublicGroups = () => {
  return async (dispatch, getState) => {
    dispatch({ type: TOGGLE_LOADING, payload: true });

    try {
      const apiResponse = await userpost("", {
        query: LIST_PUBLIC_GROUPS,
      });

      if (apiResponse?.data?.data?.list_public_groups?.data) {
        const groupData = apiResponse?.data?.data?.list_public_groups?.data;
        dispatch({
          type: SAVE_PUBLIC_GROUPS,
          payload: { list: groupData },
        });
      }
      dispatch({ type: TOGGLE_LOADING, payload: false });
    } catch (error) {
      console.error("Error fetching user games:", error);
    } finally {
      dispatch({ type: TOGGLE_LOADING, payload: false });
    }
  };
};

export const resetPublicGroups = () => ({
  type: RESET_PUBLIC_GROUPS,
});

export const joinToGroup = (groupId) => {
  return async (dispatch, getState) => {
    dispatch({ type: TOGGLE_LOADING, payload: true });

    try {
      const apiResponse = await userpost("", {
        query: JOIN_GROUP,
        variables: {
          group_id: groupId,
        },
      });
      if (apiResponse?.data?.data?.add_user_to_group?.success) {
        dispatch({ type: TOGGLE_LOADING, payload: false });
        dispatch(listPublicGroups());
      }
    } catch (error) {
      console.error("Error adding", error);
    } finally {
      dispatch({ type: TOGGLE_LOADING, payload: false });
    }
  };
};

export const fetchUserCard = (username, gameId) => {
  return async (dispatch) => {
    dispatch({ type: TOGGLE_LOADING, payload: true });

    try {
      let apiResponse = await usergamePost("", {
        query: GET_CURRENT_CARD_DATA,
        variables: {
          username,
          game_id: gameId,
        },
      });

      if (apiResponse?.data?.customStatus) {
        const data = apiResponse?.data?.data?.list_user_cards?.data;
        const cardData = data.card;
        dispatch({
          type: "SAVE_USER_CARD",
          payload: {
            gameId: data.game_id._id,
            cardData,
          },
        });
      }
    } catch (e) {
      console.error("Error fetching user card:", e);
    }

    dispatch({ type: TOGGLE_LOADING, payload: false });
  };
};

export const resetUserCards = () => ({
  type: RESET_USER_CARDS,
});
